//@flow

import { Map } from 'immutable';
import {
  LOAD_VIDEOS_DETAILS_SUCCESS,
  LOAD_VIDEOS_DETAILS_FAIL,
  LOAD_VIDEO_TRACK_SUCCESS,
  LOAD_VIDEO_TRACK_FAIL,
  SET_SELECTED_VIDEO_INDEX,
  SELECTED_VIDEO_INDEX,
  VIDEOS,
  VIDEO_TRACK,
  FLIGHT_ID,
  ERROR,
  CLEAR_ERROR,
  DELETE_VIDEO_SUCCESS,
  DELETE_VIDEO_FAIL,
  IS_STREAM_TRANSMITING,
  SET_STREAM_TRANSMITING,
  HLS_URL
} from './../types/video';

import {
  SIGN_OUT,
} from './../types/auth';

import type { VideoMetaData, VideoAction } from './../types/video';

const INITIAL_MAP = Map({
  [VIDEOS]: [],
  [SELECTED_VIDEO_INDEX]: null,
  [VIDEO_TRACK]: [],
  [FLIGHT_ID]: null,
  [ERROR]: { type: 'info', text: '' },
  [IS_STREAM_TRANSMITING]: false,
  [HLS_URL]: ''
});

export default (state: Map<string, number | Array<VideoMetaData>> = INITIAL_MAP, action: VideoAction) => {
  switch (action.type) {
    case LOAD_VIDEOS_DETAILS_SUCCESS:
      return state
        .set(VIDEOS, action[VIDEOS])
        .set(FLIGHT_ID, action[FLIGHT_ID]);

    case LOAD_VIDEOS_DETAILS_FAIL:
      return state
        .set(VIDEOS, [])
        .set(FLIGHT_ID, null);

    case LOAD_VIDEO_TRACK_SUCCESS:
      return state
        .set(VIDEO_TRACK, action[VIDEO_TRACK]);

    case LOAD_VIDEO_TRACK_FAIL:
      return state
        .set(VIDEO_TRACK, [])
        .set(ERROR, { type: 'error', text: 'Error while getting video track' });

    case SET_SELECTED_VIDEO_INDEX:
      return state
        .set(SELECTED_VIDEO_INDEX, action.index)

    case DELETE_VIDEO_SUCCESS:
      const currentIndex = state.get(SELECTED_VIDEO_INDEX);
      const newCurrentIndex = currentIndex === 0 ? 0 : currentIndex - 1;
      const newVideos = state.get(VIDEOS).filter(video => {
        return video.id !== action.id;
      });
      return state
        .set(SELECTED_VIDEO_INDEX, newCurrentIndex)
        .set(VIDEOS, newVideos);
    
    case DELETE_VIDEO_FAIL:
      return state
        .set(ERROR, { type: 'error', text: 'Error occured while deleting video' });
    
    case CLEAR_ERROR:
      return state.set(ERROR, { type: 'info', text: '' });
    
    case SET_STREAM_TRANSMITING:
      const { isStreamTransmiting } = action;
      if (isStreamTransmiting === false) {
        return state
          .set(IS_STREAM_TRANSMITING, isStreamTransmiting)
      }
      else {
        return state
          .set(IS_STREAM_TRANSMITING, action.isStreamTransmiting)
          .set(HLS_URL, action.hlsUrl)
      }

    case SIGN_OUT:
      return INITIAL_MAP;

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/video.jsx